export const showItems = function (el) {
    el.querySelectorAll(".autoloadable-item").forEach(function (item) {
        item.classList.add("loaded");
    });
};
